"use client";

import { useEffect } from 'react';
import { trackWebsiteInteraction } from './conversions.mjs';

export default function WebsiteInteractionTracking() {
  useEffect(() => {
    const handleClick = (event) => {
      if (!event.isTrusted || (event.type === 'auxclick' && event.button !== 1)) return;
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      if (!target || target.closest('input:not([type="button"]):not([type="submit"]):not([type="reset"]), textarea, select, [contenteditable="true"], [data-analytics-ignore]')) return;
      const control = target.closest('a[href], button, [role="button"], summary, input[type="button"], input[type="submit"], input[type="reset"], [data-analytics-interaction]');
      if (!control || control.matches(':disabled') || control.closest('[aria-disabled="true"], [inert]')) return;

      let kind = control.getAttribute('data-analytics-interaction') || 'button';
      const href = control.getAttribute('href');
      if (href && !control.hasAttribute('data-analytics-interaction')) {
        try {
          const url = new URL(href, window.location.href);
          if (url.protocol === 'tel:') kind = 'phone';
          else if (url.protocol === 'mailto:') kind = 'email';
          else if (!['http:', 'https:'].includes(url.protocol)) return;
          else if (url.origin !== window.location.origin) kind = 'external_link';
          else if (/^\/(?:th\/|en\/)?blog(?:\/|$)/.test(url.pathname)) kind = 'blog';
          else kind = 'navigation';
        } catch {
          return;
        }
      }
      trackWebsiteInteraction(kind);
    };

    // Capture before Next.js handles navigation or a popup stops propagation.
    // Do not prevent navigation or wait for analytics to complete.
    document.addEventListener('click', handleClick, true);
    document.addEventListener('auxclick', handleClick, true);
    return () => {
      document.removeEventListener('click', handleClick, true);
      document.removeEventListener('auxclick', handleClick, true);
    };
  }, []);

  return null;
}
